import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import storeClient from "@/store/storeClient";
import storeAuth from "@/store/storeAuth";
import storeSnackbar from "@/store/storeSnackbar";
import storeDelivery from "@/store/storeDelivery";
import storeImageSize from "@/store/storeImageSize";
import storeImageDiscount from "@/store/storeImageDiscount";
import storePromoCode from "@/store/storePromoCode";
import storePaperType from "@/store/storePaperType";
import storeModPhotoOrderUploadService from "@/store/storeModPhotoOrderUploadService";
import storeCart from "@/store/storeCart";
import storeOrders from "@/store/storeOrders";
import storeClientCounters from "@/store/storeClientCounters";
import storePromoCodeUsed from "@/store/storePromoCodeUsed";
import storeCartWaiting from "@/store/storeCartWaiting";
import storeOrderDay from "@/store/storeOrderDay";
import storeOrderDayFull from "@/store/storeOrderDayFull";
import storeRoom from "@/store/storeRoom";
import storeOrderMonth from "@/store/storeOrderMonth";
import storeGiftCategory from "@/store/storeGiftCategory";
import storeGiftSuperCategory from "@/store/storeGiftSuperCategory";
import storeGift from "@/store/storeGift";
import storeImageTemplate from "@/store/storeImageTemplate";
import storeVersion from "@/store/storeVersion";
import storeImageDatabaseCategory from "@/store/storeImageDatabaseCategory";
import storeImageDatabase from "@/store/storeImageDatabase";
import storePhotoGiftOrderDesign from "@/store/storePhotoGiftOrderDesign";
import storeGiftCard from "@/store/storeGiftCard";
import storeError from "@/store/storeError";

import {
  checkBrowser,
  checkOS,
  checkMemory,
  isFacebookApp,
} from "@/mixins/utils";

export default new Vuex.Store({
  state: {
    packageVersion: process.env.VUE_APP_VERSION || "0",
    browser: "",
    memory: "",
    os: "",
    maxCanvasSize: {
      width: 4090,
      height: 4090
    },
    fbApp: false,
  },
  getters: {
    appVersion: (state) => {
      return state.packageVersion;
    }
  },
  actions: {
    fbApp({ commit }) {
      commit("isFBApp", isFacebookApp());
    },
    getBrowser({ commit }) {
      commit("getBrowser", checkBrowser());
    },
    getMemory({ commit }) {
      commit("getMemory", checkMemory());
    },
    getOS({ commit }) {
      commit("getOS", checkOS());
    },
  },
  mutations: {
    isFBApp(state, payload) {
      state.fbApp = payload;
    },
    getBrowser(state, payload) {
      state.browser = payload;
    },
    getMemory(state, payload) {
      state.memory = payload;
    },
    getOS(state, payload) {
      state.os = payload;
      if (payload == "iOS") {
        state.maxCanvasSize = {
          width: 4090, height: 4090
        }
      } else if (payload == "Android") {
        state.maxCanvasSize = {
          width: 5120, height: 5120
        }
      } else {
        state.maxCanvasSize = {
          width: 8180, height: 8180
          //width: 4000, height: 4000
        }
      }
    },
    getMaxCanvasSize(state, payload) {
      state.maxCanvasSize = payload;
      //state.maxCanvasSize.width = 4000;
      //state.maxCanvasSize.height = 4000; // za test
    },
  },
  modules: {
    storeAuth,
    storeClient,
    storeSnackbar,
    storeDelivery,
    storeImageSize,
    storeImageDiscount,
    storePromoCode,
    storePaperType,
    storeModPhotoOrderUploadService,
    storeCart,
    storeOrders,
    storeClientCounters,
    storePromoCodeUsed,
    storeCartWaiting,
    storeOrderDay,
    storeOrderDayFull,
    storeRoom,
    storeOrderMonth,
    storeGiftCategory,
    storeGiftSuperCategory,
    storeGift,
    storeImageTemplate,
    storeVersion,
    storeImageDatabaseCategory,
    storeImageDatabase,
    storePhotoGiftOrderDesign,
    storeGiftCard,
    storeError,
  },
});
